var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import "@shoelace-style/shoelace/dist/components/dialog/dialog";
import "./wh-button";
import "./wh-icon";
let WhModalElement = class WhModalElement extends LitElement {
    constructor() {
        super(...arguments);
        this.label = "";
        this.open = false;
        this.fitContent = false;
        this.flat = false;
        this.noHeader = false;
    }
    hideModal() {
        this.open = false;
    }
    showModal() {
        this.open = true;
    }
    getDialogStyles() {
        const styles = {};
        if (this.fitContent) {
            styles["--width"] = "fit-content";
        }
        return styles;
    }
    renderHeader() {
        const buttonVariant = this.flat ? "text-flat" : "text";
        return this.noHeader
            ? nothing
            : html ` <slot name="modal-header" slot="label">
          ${this.label}
          <wh-button
            variant=${buttonVariant}
            @click=${this.hideModal}
            class="wh-modal-close"
          >
            <slot name="close-button-content">
              <wh-icon slot="prefix" name="x-circle" label="Close"></wh-icon>
              Close
            </slot>
          </wh-button></slot
        >`;
    }
    /* We have to style this dynamically to style the proper part for background color. */
    render() {
        return html `
      <sl-dialog
        style=${styleMap(this.getDialogStyles())}
        ?open=${this.open}
        ?noHeader=${this.noHeader}
        exportparts="title, header, overlay"
        @sl-hide=${this.hideModal}
      >
        ${this.renderHeader()}
        <slot></slot>
      </sl-dialog>
    `;
    }
};
WhModalElement.styles = css `
    :host {
      display: block;

      --wh-dimension-spacer-xs: 16px;
      --wh-modal-background-color: var(--wh-palette-colors-white, white);
    }

    sl-dialog::part(close-button) {
      display: none;
    }

    sl-dialog::part(close-button__base) {
      display: none;
      color: var(--wh-theme-colors-primary, hotpink);
    }

    sl-dialog::part(panel) {
      border-radius: 16px;
      background-color: var(--wh-modal-background-color, hotpink);
    }

    sl-dialog::part(body) {
      padding: 0;
    }

    sl-dialog::part(header) {
      font-family: var(
        --wh-typography-font-family,
        "Source Sans Pro",
        helvetica,
        arial
      );
      font-weight: bold;
      font-size: 27px;
      color: black;
    }

    sl-dialog::part(title) {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;
      position: relative;
    }

    :host([noHeader]) sl-dialog::part(title) {
      padding: 0;
    }

    sl-dialog::slotted(label) {
      display: flex;
      justify-content: space-between;
    }

    slot[name="modal-header"] {
      width: 100%;
    }

    .wh-modal-close {
      position: absolute;
      top: var(--wh-dimension-spacer-xs);
      right: 0;
      padding-right: var(--body-spacing);
    }
  `;
__decorate([
    property()
], WhModalElement.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WhModalElement.prototype, "open", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WhModalElement.prototype, "fitContent", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WhModalElement.prototype, "flat", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WhModalElement.prototype, "noHeader", void 0);
WhModalElement = __decorate([
    customElement("wh-modal")
], WhModalElement);
export { WhModalElement };
